// Core imports
import * as React from 'react';
import * as moment from 'moment';
import Input from 'src/components/common/Input';
import Button from 'src/components/common/Button';
import DateSingle from 'src/components/common/DateSingle';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Alert from 'src/components/common/Alert';
import { IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import i18n from 'src/translation/i18n';
import { IInitialState } from 'src/store/initialState';

interface ISamsungOrderInvoiceSearchForm {
  t?: any;
  samsungOrderInvoiceForm: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'];
  paginationRequest: any;
  searchOrdersAndInvoices(
    samsungSearchForm: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'],
    paginationRequest: any
  ): void;
  handleChangeOnSamsungForm(formValue: any): void;
}

interface ISamsungOrderInvoiceSearchFormState {
  action: string;
  productCode: string;
  palletRegNumber: string;
  customerCode: string;
  orderNumber: string;
  orderReference: string;
  ticket: string;
  dateFrom: moment.Moment;
  dateTo: moment.Moment;
}

class SamsungOrderInvoiceSearchForm extends React.Component<
  ISamsungOrderInvoiceSearchForm,
  ISamsungOrderInvoiceSearchFormState
> {
  constructor(props: any) {
    super(props);
    this.state = this.props.samsungOrderInvoiceForm;
    this.handleRplAccountChange = this.handleRplAccountChange.bind(this);
    this.handleASCAccountChange = this.handleASCAccountChange.bind(this);
    this.handleASCPONumberChange = this.handleASCPONumberChange.bind(this);
    this.handleServiceTicketChange = this.handleServiceTicketChange.bind(this);
    this.handleRplSalesOrderChange = this.handleRplSalesOrderChange.bind(this);
    this.handlePartNumberChange = this.handlePartNumberChange.bind(this);
    this.handleDateFromChange = this.handleDateFromChange.bind(this);
    this.handleDateToChange = this.handleDateToChange.bind(this);
    this.handleSamsungFormSubmit = this.handleSamsungFormSubmit.bind(this);
    this.handleSearchFormClear = this.handleSearchFormClear.bind(this);
  }

  private handleRplAccountChange(eventValue: any) {
    this.setState({ customerCode: eventValue });
  }

  private handleASCAccountChange(eventValue: any) {
    this.setState({ palletRegNumber: eventValue });
  }

  private handleASCPONumberChange(eventValue: any) {
    this.setState({ orderReference: eventValue });
  }

  private handleServiceTicketChange(eventValue: any) {
    this.setState({ ticket: eventValue });
  }

  private handleRplSalesOrderChange(eventValue: any) {
    this.setState({ orderNumber: eventValue });
  }

  private handlePartNumberChange(eventValue: any) {
    this.setState({ productCode: eventValue });
  }

  private handleDateFromChange(dateFromValue: moment.Moment) {
    this.setState({ dateFrom: dateFromValue });
  }

  private handleDateToChange(dateToValue: moment.Moment) {
    this.setState({ dateTo: dateToValue });
  }

  private handleSamsungFormSubmit() {
    this.props.handleChangeOnSamsungForm(this.state);
    this.props.searchOrdersAndInvoices(
      this.state,
      this.props.paginationRequest
    );
  }
  public componentDidMount() {
    this.handleSamsungFormSubmit();
  }

  private handleSearchFormClear() {
    const clearForm: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'] = {
      action: 'SEARCH',
      productCode: '',
      palletRegNumber: '',
      customerCode: '',
      orderNumber: '',
      orderReference: '',
      ticket: '',
      dateFrom: null,
      dateTo: null
    };
    this.props.handleChangeOnSamsungForm(clearForm);
    this.setState(clearForm);
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-samsungOrderInnerBlock">
        <div className="rp-samsungOrderSearchParameter">
          <Input
            label={i18n.t('samsungOrder.rplAccount')}
            value={this.state.customerCode}
            onChange={this.handleRplAccountChange}
          />
          <Input
            label={i18n.t('samsungOrder.ascAccount')}
            value={this.state.palletRegNumber}
            onChange={this.handleASCAccountChange}
          />
          <Input
            label={i18n.t('samsungOrder.ascpoNumber')}
            value={this.state.orderReference}
            onChange={this.handleASCPONumberChange}
          />
          <div className="rp-input dateField">
            <label>{i18n.t('samsungOrder.orderDateFrom')}</label>
            <DateSingle
              onDateSelected={this.handleDateFromChange}
              date={this.state.dateFrom}
            />
          </div>
          <Input
            label={i18n.t('samsungOrder.serviceTicket')}
            value={this.state.ticket}
            onChange={this.handleServiceTicketChange}
          />
          <Input
            label={i18n.t('samsungOrder.rplSalesOrder')}
            value={this.state.orderNumber}
            onChange={this.handleRplSalesOrderChange}
          />
          <Input
            label={i18n.t('samsungOrder.partNumber')}
            value={this.state.productCode}
            onChange={this.handlePartNumberChange}
          />
          <div className="rp-input dateField">
            <label>{i18n.t('samsungOrder.orderDateTo')}</label>
            <DateSingle
              onDateSelected={this.handleDateToChange}
              date={this.state.dateTo}
            />
          </div>
        </div>
        <div className="rp-input rp-fullrow">
          {/* <div className="hide">
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  // this.setState({ error: '' });
                }}
              >
                <MatrialCloseIcon fontSize="inherit" />
              </IconButton>
            }
            severity="error"
          >
            {t('myFavourites.enterNameError')}
          </Alert>
          </div> */}
          {/* {this.state.PONumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxPoCharacterErr', {
                      count: 15
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      // PONumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )} */}
          <Alert
            styleClass="errorPoNumberAlert hide"
            message={`Error message`}
            icon={'rpds-error'}
            handleCloseAlert={() => {
              this.setState({
                // PONumberAlert: false
              });
            }}
            type={'error'}
          />
          <div className="flex-space" />
          <div className="button-wrapper">
            <Button
              buttonClass="primary-button login-button mr-10"
              label={i18n.t('common.search')}
              action={this.handleSamsungFormSubmit}
            />
            <Button
              buttonClass="primary-button login-button"
              label={i18n.t('common.clear')}
              action={this.handleSearchFormClear}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SamsungOrderInvoiceSearchForm;
